import React from "react";

const HighlightShapeThree = () => {
  return (
    <svg width="240" height="22" viewBox="0 0 240 22" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.440833 21.1152C78.9497 6.16225 158.05 4.53412 235.949 13.8239C237.497 14.0088 239.796 12.4065 239.988 9.93474C240.181 7.4176 238.026 5.44088 236.474 5.2332C157.99 -5.31675 79.1936 0.359501 0.316568 19.7785C-0.184784 19.9023 -0.0511379 21.2092 0.440833 21.1152Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default HighlightShapeThree;
